export default __webpack_public_path__ + "static/media/pingy.7ec0386f.svg";